import { render, staticRenderFns } from "./RedeemPassModal.vue?vue&type=template&id=5a6c1ffa&scoped=true"
import script from "./RedeemPassModal.vue?vue&type=script&lang=js"
export * from "./RedeemPassModal.vue?vue&type=script&lang=js"
import style0 from "./RedeemPassModal.vue?vue&type=style&index=0&id=5a6c1ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c1ffa",
  null
  
)

export default component.exports